import type { State } from 'state';
import type { DefaultError } from '@atlassian/help-center-common-util/errors';
import type { PersistedError } from 'state/persisted/types';

export const getInitialError = (state: State): PersistedError | undefined => {
    return state.persisted.completeSignup.initialError;
};

export const getSignupToken = (state: State): string => {
    return state.persisted.completeSignup.signupToken;
};

export const getEmailAddress = (state: State): string => {
    return state.persisted.completeSignup.emailAddress;
};

export const getValidationOutcome = (state: State): string | undefined => {
    return state.persisted.completeSignup.validationOutcome;
};

export const getPortalId = (state: State): number | undefined => {
    return state.persisted.completeSignup.portalId;
};

export const getRedirectUrl = (state: State): string | undefined => {
    return state.persisted.completeSignup.redirectUrl;
};

export const getIsSubmitting = (state: State): boolean => {
    return state.ui.completeSignup.isSubmitting;
};

export const getSubmitError = (state: State): DefaultError | undefined => {
    return state.ui.completeSignup.submitError;
};

export const getIsNewSignupLinkBeingSent = (state: State): boolean => {
    return state.ui.completeSignup.isNewSignupLinkBeingSent;
};

export const getNewSignupLinkSuccessfullySent = (state: State): boolean => {
    return state.ui.completeSignup.newSignupLinkSuccessfullySent;
};
